import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { getNotificationSummary } from "@/lib/apiClient";
import {useVisibleRefresh} from "@/lib/useVisibleRefresh";
import {readAccessLost} from "@/lib/userError";

export function NotificationBell() {
  const [count, setCount] = useState(null);
  const [failed, setFailed] = useState(false);
  const [stale, setStale] = useState(false);
  const [updatedAt,setUpdatedAt]=useState(null);
  const [accessLost,setAccessLost]=useState(false);
  const refresh=useRef(()=>{});
  useEffect(() => {
    let active = true, busy = false;
    const check = async () => {
      if (busy || document.visibilityState !== "visible" || navigator.onLine===false) return;
      busy = true;
      try {
        const result = await getNotificationSummary();
        if (active) {setCount(result.unread); setStale(result.stale); setFailed(false);setAccessLost(false);setUpdatedAt(new Date());}
      } catch(error) {if (active) {setFailed(true);if(readAccessLost(error)){setCount(null);setUpdatedAt(null);setAccessLost(true);}}}
      finally {busy = false;}
    };
    check();
    refresh.current=check;
    window.addEventListener("acai-notifications-changed", check);
    return () => {active = false; refresh.current=()=>{};window.removeEventListener("acai-notifications-changed", check);};
  }, []);
  useVisibleRefresh(()=>refresh.current(),{enabled:!accessLost,intervalMs:30000,updatedAt});
  return <Link to="/notifications" className="header-round-button relative" aria-label={failed ? "Ilmoitukset — päivitys epäonnistui" : stale ? "Ilmoitukset — ajantasaisuutta ei ole varmistettu" : count === null ? "Ilmoitukset — ladataan" : `Ilmoitukset, ${count} lukematonta`}>
    <Bell className="h-5 w-5" />
    {Boolean(count) && <span aria-hidden="true" className="absolute -right-1 -top-1 rounded-full bg-primary px-1.5 text-xs font-bold text-primary-foreground">{count > 99 ? "99+" : count}</span>}
    {(failed || stale) && <span aria-hidden="true" className="absolute bottom-0 right-0 rounded-full bg-amber-500 px-1 text-xs text-black">!</span>}
  </Link>;
}
